import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ExamType } from '@tsin-core/entities';
import { ICreateExamFee, IExamFee, IUpdateExamFee } from '@tsin-core/models/exam-fee.model';
import { environment } from '@tsin-env/environment';
import { Observable } from 'rxjs';

const EXAM_FEE_URL = `${environment.apiUrl}/fees`;

@Injectable({
  providedIn: 'root',
})
export class ExamFeeService {
  constructor(private http: HttpClient) { }

  createExamFee(payload: Omit<ICreateExamFee, 'id'>): Observable<any> {
    return this.http.post<any>(EXAM_FEE_URL, payload);
  }

  updateExamFee(payload: Omit<IUpdateExamFee, 'id'>): Observable<any> {
    return this.http.post<any>(EXAM_FEE_URL, payload);
  }

  getExamFee(): Observable<any> {
    return this.http.get<any>(`${EXAM_FEE_URL}`);
  }

  getExamFeeByType(examType: ExamType): Observable<{ data: IExamFee[] }> {
    return this.http.get<{ data: IExamFee[] }>(`${environment.apiUrl}/exams/fees/${examType}`);
  }

  // deleteExamFee(id: string): Observable<any> {
  //   return this.http.delete<any>(`${EXAM_FEE_URL}/${id}`);
  // }
}